$shm_hitalama_map_widget_float_code_ts $shm_hitalama_map_widget_float_code_js
	textarea_hint \typescript
